import React from "react";
import { BookOpenIcon, InstagramIcon, MapPinIcon, MegaphoneIcon, MonitorIcon, SearchIcon, ShoppingBagIcon, TargetIcon, BoxIcon } from "lucide-react";
import { SectionHeading } from "./SectionHeading";
import { services } from "../data/services";
const icons: Record<string, BoxIcon> = {
  monitor: MonitorIcon,
  target: TargetIcon,
  'map-pin': MapPinIcon,
  megaphone: MegaphoneIcon,
  search: SearchIcon,
  instagram: InstagramIcon,
  'book-open': BookOpenIcon,
  'shopping-bag': ShoppingBagIcon
};
export function Services() {
  const [primary, secondary, ...rest] = services;
  return <section id="servicios" className="scroll-mt-24 border-t border-white/8 bg-ink-900 py-20 lg:py-28" data-id="element-222" data-mp="u5s4pzqrfq8b">
      <div className="mx-auto max-w-page px-5 lg:px-8" data-id="element-223" data-mp="q4zw98ppppd3">
        <SectionHeading title="Servicios digitales para hacer crecer tu negocio" subtitle="No diseñamos páginas bonitas sin estrategia. Creamos herramientas digitales pensadas para atraer clientes, generar confianza y facilitar la venta." data-id="element-224" data-mp="q2ddse1a9pg3" />

        <div className="mt-12 grid gap-6 lg:grid-cols-2" data-id="element-225" data-mp="36bxyshvjkdgw">
          {[primary, secondary].map(service => {
          const Icon = icons[service.icon];
          return <article key={service.id} className="flex flex-col rounded-2xl border border-neon/30 bg-ink-800 p-7 lg:p-9" data-id="element-226" data-mp="3b5apqynp0wct">
                <span className="grid h-12 w-12 place-items-center rounded-xl border border-neon/40 bg-neon/10 text-neon" data-id="element-227" data-mp="32aw1i6l6qbhk">
                  <Icon className="h-5 w-5" aria-hidden="true" strokeWidth={1.5} data-id="element-228" data-mp="3q075dwxu0lzx" />
                </span>
                <h3 className="mt-6 text-xl font-semibold leading-snug text-white" data-id="element-229" data-mp="3u10rqlvmlsqp">
                  {service.title}
                </h3>
                <p className="mt-4 text-sm leading-relaxed text-mist-muted" data-id="element-230" data-mp="3g4dibjmhla3w">
                  {service.description}
                </p>
              </article>;
        })}
        </div>

        <div className="mt-6 grid gap-6 sm:grid-cols-2 lg:grid-cols-3" data-id="element-231" data-mp="24lj6ne4inb7w">
          {rest.map(service => {
          const Icon = icons[service.icon];
          return <article key={service.id} className="flex flex-col rounded-2xl border border-white/8 bg-ink-800/60 p-6 transition-colors duration-200 ease-out hover:border-neon/40" data-id="element-232" data-mp="1pkm3ttvkplsl">
                <span className="grid h-10 w-10 place-items-center rounded-lg border border-neon/30 text-neon" data-id="element-233" data-mp="1grsjhi19rw7v">
                  <Icon className="h-4 w-4" aria-hidden="true" strokeWidth={1.5} data-id="element-234" data-mp="1bsxv80kj9fgd" />
                </span>
                <h3 className="mt-5 text-base font-semibold leading-snug text-white" data-id="element-235" data-mp="16u4elz9y98bz">
                  {service.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-mist-muted" data-id="element-236" data-mp="11syl3z8gth1e">
                  {service.description}
                </p>
              </article>;
        })}
        </div>
      </div>
    </section>;
}